import { render, staticRenderFns } from "./CompaniesDeleteDoc.vue?vue&type=template&id=36c43f52"
import script from "./CompaniesDeleteDoc.vue?vue&type=script&lang=js"
export * from "./CompaniesDeleteDoc.vue?vue&type=script&lang=js"
import style0 from "./CompaniesDeleteDoc.vue?vue&type=style&index=0&id=36c43f52&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports